import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'userLots',
    standalone: false
})
export class UserLotsPipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.slice(0, value.length - 2) : '';
  }

}
